export enum Location {
  Global = 'Global',
  US = 'Us',
  NonUS = 'NonUs',
}
